export default __webpack_public_path__ + "static/media/leg-left-front.d257ec61.png";